import { render, staticRenderFns } from "./EditContactInformation.vue?vue&type=template&id=19cad2e8&lang=pug"
import script from "./EditContactInformation.vue?vue&type=script&lang=js"
export * from "./EditContactInformation.vue?vue&type=script&lang=js"
import style0 from "./EditContactInformation.vue?vue&type=style&index=0&id=19cad2e8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports